import { theme as antdTheme } from 'antd';

export const APPEARANCE_THEMES = Object.freeze({
  LIGHT: 'light',
  DARK: 'dark',
});

export const normalizeAppearanceTheme = (value) =>
  value?.toLowerCase() === APPEARANCE_THEMES.DARK
    ? APPEARANCE_THEMES.DARK
    : APPEARANCE_THEMES.LIGHT;

const lightTheme = {
  algorithm: antdTheme.defaultAlgorithm,
  token: {
    colorPrimary: '#3BB0F0',
    colorLink: '#0B5C8C',
    colorError: '#B42318',
    colorText: '#0E1A2B',
    colorTextSecondary: '#425063',
    colorTextTertiary: '#53616F',
    colorTextQuaternary: '#5F6B78',
    colorBorder: '#E6EBF0',
    colorBgLayout: '#F4F7FA',
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FFFFFF',
  },
  components: {
    Dropdown: {
      controlItemBgHover: '#E6F7FF',
    },
    Button: {
      colorPrimary: '#0860DB',
    },
    Checkbox: {
      colorPrimary: '#0860DB',
    },
    Switch: {
      colorPrimary: '#0860DB',
      colorPrimaryHover: '#0751B8',
    },
    Table: {
      rowHoverBg: '#E6F7FF',
      rowSelectedBg: '#E6F7FF',
      borderColor: '#DADCE0',
    },
  },
};

const darkTheme = {
  algorithm: antdTheme.darkAlgorithm,
  token: {
    colorPrimary: '#3BB0F0',
    colorLink: '#5CC0F5',
    colorError: '#FF7875',
    colorText: '#EDF2F8',
    colorTextSecondary: '#B8C3D0',
    colorTextTertiary: '#8E9AA8',
    colorTextQuaternary: '#8492A3',
    colorBorder: '#586F89',
    colorBgLayout: '#0B1420',
    colorBgContainer: '#111C2B',
    colorBgElevated: '#203550',
  },
  components: {
    Dropdown: {
      controlItemBgHover: '#17283A',
    },
    Button: {
      colorPrimary: '#0860DB',
    },
    Checkbox: {
      colorPrimary: '#0860DB',
    },
    Switch: {
      colorPrimary: '#0860DB',
      colorPrimaryHover: '#0751B8',
    },
    Table: {
      rowHoverBg: '#17283A',
      rowSelectedBg: '#173B52',
      borderColor: '#27364A',
    },
  },
};

export const getDmsThemeConfig = (appearanceTheme) =>
  normalizeAppearanceTheme(appearanceTheme) === APPEARANCE_THEMES.DARK
    ? darkTheme
    : lightTheme;
